import React, { useCallback, useState } from 'react';
import AspectRatio from 'react-aspect-ratio';
import { Link } from '../../../../Link';
import { CardProps } from './CollectionCard';

export function CollectionCardLandscape({ card }: CardProps): React.ReactNode {
  const [activeImage, setActiveImage] = React.useState(card.image.url);

  const gradient = `linear-gradient(to top, ${card.background.gradientColor}, rgba(10,15,44, 0))`;
  const activeGradient = `linear-gradient(to top, ${card.background.activeGradientColor}, rgba(10,15,44, 0))`;

  const [hovered, setHovered] = useState(false);

  const onEnter = useCallback(() => {
    setActiveImage(card.image.activeUrl);
    setHovered(true);
  }, [card.image.activeUrl]);

  const onExit = useCallback(() => {
    setActiveImage(card.image.url);
    setHovered(false);
  }, [card.image.url]);

  const scaling = card.background.imageUrl
    ? 'hover:scale-s'
    : 'hover:scale-s 768:hover:scale-l 1920:hover:scale-s ';

  const hasBackgroundImage = Boolean(card.background.imageUrl);
  const showTitle = Boolean(card.title) && !hasBackgroundImage;

  return (
    <div
      key={card.id}
      className="h-full select-none flex-shrink-0"
      data-testid="contentprovider_card"
      onMouseEnter={onEnter}
      onMouseLeave={onExit}
    >
      <div
        className={`flex flex-1 scaling  flex-col justify-center items-center w-full mb-1 ${scaling}`}
        style={{ backgroundColor: card.background.backgroundColor }}
      >
        <div className="w-full relative">
          <Link destination={card.destination}>
            {hasBackgroundImage && (
              <div className="relative">
                <AspectRatio ratio="2/3" className="w-full">
                  <img
                    src={card.background.imageUrl ?? ''}
                    className={`w-full object-cover ${
                      card.background.imageUrl === '' && 'opacity-0'
                    }`}
                    alt=""
                    title=""
                  />
                </AspectRatio>
              </div>
            )}

            {hasBackgroundImage ? (
              <div
                style={{
                  backgroundImage: hovered ? activeGradient : gradient,
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  zIndex: 5,
                  right: 0,
                  top: '20%',
                }}
              ></div>
            ) : null}

            {card?.image.url ? (
              <div
                className={hasBackgroundImage ? 'absolute bottom-[0px] left-0 right-0 z-40' : ''}
              >
                <AspectRatio ratio="16/9" className="w-full">
                  <img src={activeImage} className="w-full h-12" alt="" title="" />
                </AspectRatio>
              </div>
            ) : null}

            {showTitle ? (
              <div className="flex flex-col items-center w-full z-10">
                <div className="w-full">
                  <div className="w-full" />
                </div>
                <div className="text-marker-xs mt-1 mb-4 1440:mt-4 1440:mb-6 text-white z-20">
                  {card.title}
                </div>
              </div>
            ) : null}
          </Link>
        </div>
      </div>
    </div>
  );
}
